<template>
    <div class="w-full h-full flex flex-col">
        <h1 class="text-brand text-lg font-extrabold mb-2 border-gray-200 border-b h-8 overflow-hidden">
            <span class="ml-4 whitespace-nowrap"><i class="fa fa-wrench mr-4"></i>Equipment On Site</span>
        </h1>
        <main class="overflow-hidden flex-1 place-content-center">
            <div v-if="loaded" class="flex flex-col text-gray-500 cursor-pointer" @click="go">
                <div class="w-full text-center text-5xl hover:text-brand" v-if="countOnSite" v-text="countOnSite"></div>
                <div class="place-content-center w-full" v-else>
                    <div class="flex flex-col text-gray-500">
                        <div class="w-full text-center font-bold text-md"><span><i
                            class="text-lg text-green-600 far fa-check mr-4"></i></span>No Equipment Currently On Site
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {Equipment} from "@models";

export default {
    components: {},
    props: {
        dashboardData: Object,
        dashboardProps: Object,
    },
    data() {
        return {
            loaded: false,
            countOnSite: null
        }
    },
    computed: {},
    methods: {
        go(){
            window.document.location = route('mobile.packages.equipment',[this.dashboardProps.legacyPackage.id])
        }
    },
    async mounted() {
        let equipment = await Equipment.byPackageReference(this.dashboardProps.legacyPackage.reference)
        this.loaded = true;
        this.countOnSite = equipment.filter((i) => {
            return (i.inUse && (i.inUseAt === this.dashboardProps.legacyPackage.reference))
        }).length
    }
}

</script>